import config from '@/config/index';

/**
     * 增加产品
     *
     * @param productname   产品名称
     * @param producttype   分类
     * @param orgid         机构id
     * @param productdetail 产品详情
     * @param amountlower   金额下限
     * @param amountupper   金额上限
     * @param nonamount     金额面议标识 1生效
     * @param show          是否显示
     * @param img           图片
     * @param contacts      联系人
     * @param mobile        手机号
     * @param address       地址
     * @param province      省份
     * @param district      地区
     * @param request
     * @return
     */
function addProduct() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/product`;
}

function modifyProduct() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyproduct`;
}
/**
     * @param pid     产品id
     * @param request
     * @return
     */
function deleteProduct() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/deleteproduct`;
}

/**
   * @param productid 产品ID
   * @return
   */
function getProductById(pid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/product/${pid}`;
}

/**
   * @param orgid 机构ID
   * @return
   */
function getProductsByOrgid(orgid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/productsbyorgid/${orgid}`;
}



export {
    addProduct,
    modifyProduct,
    deleteProduct,
    getProductById,
    getProductsByOrgid
};
